import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-932c0c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "t-form-item-left"
}
const _hoisted_2 = {
  key: 0,
  class: "t-form-item-left__label"
}
const _hoisted_3 = { class: "t-form-item-right" }
const _hoisted_4 = {
  key: 0,
  class: "t-form-item-suffix"
}
const _hoisted_5 = {
  key: 0,
  class: "t-form-item-ft"
}
const _hoisted_6 = { class: "t-form-item-txt t-form-item-txt__error" }
const _hoisted_7 = {
  key: 1,
  class: "t-form-item-border__bot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "t-form-item" }, _ctx.$attrs, {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
  }), [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClasses.body)
    }, [
      (_ctx.label || _ctx.$slots.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "label", {}, () => [
              (_ctx.label)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.label), 1))
                : _createCommentVNode("", true)
            ], true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        (_ctx.$slots.suffix)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "suffix", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.validateState === 'error' && _ctx.showMessage && (_ctx.$slots.error || _ctx.validateMessage || _ctx.error))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "error", {}, () => [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.validateMessage || _ctx.error), 1)
          ], true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasBorder)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7))
      : _createCommentVNode("", true)
  ], 16))
}